import styled from "styled-components";
import * as PropTypes from "prop-types";

export default function TreatmentHighlight({
  children,
  selected,
  noBlue = false,
}) {
  return (
    <CenterDiv>
      <Container useBlue={!noBlue} selected={selected}>
        {children}
      </Container>
    </CenterDiv>
  );
}

TreatmentHighlight.propTypes = {
  children: PropTypes.any,
  selected: PropTypes.bool,
  noBlue: PropTypes.bool,
};

const CenterDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const Container = styled.div`
  width: 30px;
  height: 24px;
  //margin-top: -5px;
  flex-shrink: 0;
  position: relative;
  flex-grow: 0;
  z-index: 1;
  background-color: white;
  //padding-top: 12px;
  color: ${({ theme, useBlue }) => (useBlue ? theme.blue : theme.black)};
  border: solid 1px ${({ theme }) => theme.borderColor};
  border-radius: 4px;

  ${({ selected, theme }) =>
    selected && `background-color: ${theme.hoverColor}`};
  &:hover {
    background-color: ${({ theme }) => theme.hoverColor};
  }
`;
